import React from "react";

const HelpCenter = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12.875 16.875C12.875 17.3582 12.4832 17.75 12 17.75C11.5168 17.75 11.125 17.3582 11.125 16.875C11.125 16.3918 11.5168 16 12 16C12.4832 16 12.875 16.3918 12.875 16.875Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.125"
    />
    <path
      d="M12 13.5V12.75C13.6566 12.75 15 11.5744 15 10.125C15 8.67562 13.6566 7.5 12 7.5C10.3434 7.5 9 8.67562 9 10.125V10.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default HelpCenter;
